import BaseEventModel from './base-event-model';

/** Represents a data model of the "Page View" event. */
export class PageView extends BaseEventModel {
  constructor(
    public readonly timestamp: number,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly merchantId: string,
    public readonly shopperCountryCode: string,
    public readonly category: string,
    public readonly cdn: string,
    public readonly pageUrl: string,
    public readonly pageTitle: string,
    public readonly referrer: string,
    public screenResolution?: string /* (e.g. 1280x1024) */,
    public userAgent?: string,
    public utmSource?: string,
    public utmMedium?: string,
    public utmCampaign?: string,
    public utmTerm?: string,
    public utmContent?: string,
    public utmAdSet?: string,
    public borderfreeProperties?: object,
  ) {
    super('Page View', timestamp, clientId, sessionId, merchantId, shopperCountryCode, category, cdn);
  }
}

